export const LOAD_SMART_LINK = 'LOAD_SMART_LINK';
export const LOAD_SMART_LINK_ORDERS = 'LOAD_SMART_LINK_ORDERS';
export const UPDATE_SMART_LINK = 'UPDATE_SMART_LINK';
